module.exports = __webpack_public_path__ + "static/media/sucesso-da.c27cfac3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sucesso-da.svg
// module id = 2791
// module chunks = 0